import { useEffect, useState } from "react";
import Loader from "../../../Components/Loader";
import { Table } from "react-bootstrap";
import ParentStudiesTableRow from "../../../Components/AdministrativeSettings/SampleRequest/ParentStudiesTableRow";
import NoListDataAvailable from "../../../Components/NoListDataAvailable";
import TokenService from "../../../Services/Token.service";
import { getStatuses, RequestorService } from "../../../Services/Requestor.Service";
import Toaster from "../../../Components/Toaster";

import DateRangeFilter from "../../../Components/AdministrativeSettings/DateRangeFilter";
import dayjs from "dayjs";
import SearchInput from "../../../Components/AdministrativeSettings/SearchInput";
import AdminStatusDropdown from "../../../Components/AdministrativeSettings/AdminStatusDropdown";
import TablePagination from "../../../Components/AdministrativeSettings/TablePagination";
import NumberOfDonationSort from "../../../Components/AdministrativeSettings/NumberOfDonartionSort";
import { getErrorMessage } from "../../../Utils/Common";

function ParentStudiesListTable(props) {
    const [loading, setLoading] = useState(true);

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [ParentStudiesList, setParentStudiesList] = useState([]);
    const [TotalParentStudies, setTotalParentStudies] = useState([]);

    const [statuses, setStatuses] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([]);

    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, offset: 0 });

    const [StudyName, setStudyName] = useState("");
    const [isStudyNameVisible, setStudyNameInputVisible] = useState(false);

    const [createdBy, setcreatedBy] = useState("");
    const [iscreatedByVisible, setcreatedByInputVisible] = useState(false);

    const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
    const [donationSortDirection, setDonationSortDirection] = useState(null);

    const { isClearFilter } = props;
    const { onFilterCountChange } = props;
    const {refreshTrigger}= props;
    useEffect(() => {
        if (isClearFilter) {
            setSelectedStatuses([]);
            setStudyName("");
            setStudyNameInputVisible(false);

            setcreatedBy("");
            setcreatedByInputVisible(false);
            onFilterCountChange(0);
            setSelectedDateRange([null, null]);
            setDonationSortDirection(null)
        }
    }, [isClearFilter]);

    // Calculate and update the filter count
    useEffect(() => {
        const count = [
            selectedStatuses.length > 0 ? 1 : 0,
            selectedDateRange[0] && selectedDateRange[0] != null ? 1 : 0,
            StudyName ? 1 : 0,
            createdBy ? 1 : 0,
            donationSortDirection !== null ? 1 : 0,
        ].reduce((sum, val) => sum + val, 0);

        onFilterCountChange(count);
    }, [selectedStatuses, StudyName, createdBy, selectedDateRange, donationSortDirection]);

    useEffect(() => {
        fetchStatuses();
    }, []);

    useEffect(() => {
        fetchParentStudyList();
    }, [pagination, selectedStatuses, StudyName, createdBy, selectedDateRange, donationSortDirection, refreshTrigger]);
    //   selectedRoles, searchEmail, searchPhone, searchId

    function fetchParentStudyList() {
        setLoading(true);
        const userId = TokenService.getUserId();

        const filters = {
            status: (selectedStatuses.length === 0 ? [] : selectedStatuses),
            parentStudy: StudyName,
            from_date: selectedDateRange[0],
            to_date: selectedDateRange[1],
            createdBy: createdBy,
        };

        const params = {
            limit: pagination.limit,
            offset: pagination.offset,
            filters: [filters],
            user_id: userId,
            ...(donationSortDirection !== null && { sort: [{ no_of_projects: donationSortDirection }] })
        };

        RequestorService.getParentStudies(params)
            .then((response) => {
                
                setParentStudiesList(response.data);
                setTotalParentStudies(response.total_studies)
                setLoading(false);
            })
            .catch((error) => {
                console.error("Failed to fetch sample request list", error);
                setLoading(false);
            });
    }

    function fetchStatuses() {
        getStatuses()
            .then((statusTypes) => {
                setStatuses(statusTypes);
            })
            .catch((error) => {
                console.error("Failed to fetch status types", error);
            });
    }
    const handleUpdateStatus = async (studyId, status) => {
    setLoading(true);
    try {
        const userId = TokenService.getUserId();
        const payload = {
            study_id: studyId,
            user_id: userId,
            status: status
        };
        const response = await RequestorService.inactiveDeactiveDeleteParentStudy(payload);
        if (response.success) {
            setToastMessage(response.message);
            setShowToast(true);
            setToastVariant('success');
            fetchParentStudyList();
        } else {
            const message = getErrorMessage(response.message);
            setToastMessage(message);
            setShowToast(true);
            setToastVariant('error');
        }
    } catch (error) {
        const message = getErrorMessage(error);
        setToastMessage(message);
        setShowToast(true);
        setToastVariant('error');
    } finally {
        setLoading(false);
    }
};



    const handleDateRangeChange = (daterange) => {

        if (daterange[0] && daterange[1]) {
            const startDate = dayjs(daterange[0]).startOf('day').toDate();
            const endDate = dayjs(daterange[1]).endOf('day').toDate();
            const dateRangee = [startDate, endDate];

            // Set the selected date range to the adjusted date array
            setSelectedDateRange(dateRangee);

            // Reset pagination whenever the date range changes
            setPagination({ ...pagination, page: 1, offset: 0 });
        }
        else {
            setSelectedDateRange([null, null]);
        }

    };

    function handleSortDonations(direction) {
        setDonationSortDirection(direction);
        setPagination({ ...pagination, page: 1, offset: 0 });
    }


    const handleRowsPerPageChange = (newRowsPerPage) => {
        if (newRowsPerPage === 'Show All') {
            setRowsPerPage(TotalParentStudies);
            setPagination({ limit: TotalParentStudies, offset: 0, page: 1 });
        } else {
            setRowsPerPage(Number(newRowsPerPage));
            setPagination({ limit: Number(newRowsPerPage), offset: 0, page: 1 });
        }
    };

    const totalFiltered = ParentStudiesList.length;  //ex 10 
    const totalPages = Math.ceil(TotalParentStudies / rowsPerPage); // 10 / 2rpp  then  5 pages

    const handleNextPage = () => {
        setPagination({ ...pagination, offset: pagination.page * rowsPerPage, page: pagination.page + 1 });
    };

    const handlePreviousPage = () => {
        setPagination({ ...pagination, offset: (pagination.page - 2) * rowsPerPage, page: pagination.page - 1 });
    };

    const handleStatusChange = (status) => {
        if (selectedStatuses.includes(status)) {
            setSelectedStatuses(selectedStatuses.filter((s) => s !== status));
        } else {
            setSelectedStatuses([...selectedStatuses, status]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
    };
    return (<>
        <div className="">
            <Loader loading={loading} />

            <div className="el-table-container el-board-table">
                <Table hover className="table table-striped">
                    <thead>
                        <tr>
                            <th>
                                <DateRangeFilter
                                    selectedDateRange={selectedDateRange}
                                    handleDateRangeChange={handleDateRangeChange}
                                    setSelectedDateRange={setSelectedDateRange}
                                    label={"Date Created"} />
                            </th>
                            <th>
                                <SearchInput
                                    label="Parent Study"
                                    value={StudyName}
                                    setValue={setStudyName}
                                    isVisible={isStudyNameVisible}
                                    setVisible={setStudyNameInputVisible}
                                />
                            </th>
                            <th>
                                <NumberOfDonationSort handleSortDonations={handleSortDonations} sortDirection={donationSortDirection} type={'Number of Projects'} />
                            </th>
                            <th>
                                <SearchInput
                                    label="Created By"
                                    value={createdBy}
                                    setValue={setcreatedBy}
                                    isVisible={iscreatedByVisible}
                                    setVisible={setcreatedByInputVisible}
                                />
                            </th>
                            <th>
                                <AdminStatusDropdown
                                    statuses={statuses}
                                    selectedStatuses={selectedStatuses}
                                    handleStatusChange={handleStatusChange}
                                    setSelectedStatuses={setSelectedStatuses}
                                    label="Status"
                                />
                            </th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ParentStudiesList.length > 0 ? (ParentStudiesList.map((study, index) => (
                            <ParentStudiesTableRow
                                key={index}
                                study={study}
                                handleUpdateStatus = {handleUpdateStatus }
                                onEditStudy={props.onEditStudy}

                            ></ParentStudiesTableRow>
                        ))) : (
                            <NoListDataAvailable type="parent studies" />
                        )}
                    </tbody>
                </Table>
            </div>
            <TablePagination
                rowsPerPage={rowsPerPage}
                handleRowsPerPageChange={handleRowsPerPageChange}
                pagination={pagination}
                totalPages={totalPages}
                handlePreviousPage={handlePreviousPage}
                handleNextPage={handleNextPage}
                totalUsers={TotalParentStudies}
            />
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
        </div>
    </>)
}
export default ParentStudiesListTable